"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.singularCase = exports.pluralCase = exports.INVERTED_CUSTOM_WORDS = exports.CUSTOM_WORDS = exports.pluralize = void 0;
const pluralize_1 = __importDefault(require("pluralize"));
exports.pluralize = pluralize_1.default;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Custom defined words to map between singular and plural
 */
exports.CUSTOM_WORDS = {
    alexaAnalytics: 'alexaAnalyticses',
    amazonPayments: 'amazonPaymentses',
    aws: 'awses',
    contactUs: 'contactUses',
    dataPractices: 'dataPracticeses',
    googleAnalytics: 'googleAnalyticses',
    promptAPerson: 'promptAPersons',
    PromptAPerson: 'PromptAPersons',
    quickBooks: 'quickBookses',
};
/**
 * Plural to singular case
 */
exports.INVERTED_CUSTOM_WORDS = (0, type_utils_1.invert)(exports.CUSTOM_WORDS);
/**
 * Pluralize a word
 *
 * @param word - The word to pluralize
 * @returns The pluralized word
 */
function pluralCase(word) {
    return exports.INVERTED_CUSTOM_WORDS[word]
        ? word
        : exports.CUSTOM_WORDS[word] || (0, pluralize_1.default)(word);
}
exports.pluralCase = pluralCase;
/**
 * Singular tense
 *
 * @param word - The word to change case of
 * @returns The word in singular case
 */
function singularCase(word) {
    return exports.CUSTOM_WORDS[word]
        ? word
        : exports.INVERTED_CUSTOM_WORDS[word] || pluralize_1.default.singular(word);
}
exports.singularCase = singularCase;
//# sourceMappingURL=pluralization.js.map